import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import PropTypes from 'prop-types';
import { IlSearchV2DropdownItem } from '../IlSearchV2DropdownItem/index.js';
import { IlSkeletonText } from '../../IlSkeletons/IlSkeletonText/index.js';
import 'carbon-components-react';
import { cssClassPrefix } from '../../../shared/constants/generalConstants.js';
import { highlightText } from '../../../shared/utils/highlightText/index.js';

var BASE_CSS = "".concat(cssClassPrefix, "-search-v2");
var IlSearchV2Dropdown = /*#__PURE__*/function (_Component) {
  function IlSearchV2Dropdown() {
    var _this;
    _classCallCheck(this, IlSearchV2Dropdown);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, IlSearchV2Dropdown, [].concat(args));
    _defineProperty(_this, "renderDropdownItem", function (option, index) {
      var _this$props = _this.props,
        searchValue = _this$props.searchValue,
        _handleSelect = _this$props.handleSelect,
        getOptionValue = _this$props.getOptionValue,
        getOptionLabel = _this$props.getOptionLabel,
        highlightLabelText = _this$props.highlightLabelText;
      var optionLabel = getOptionLabel ? getOptionLabel(option, searchValue) : option.label;
      // eslint-disable-next-line no-nested-ternary
      var optionValue = getOptionValue ? getOptionValue(option) : option.value ? option.value : optionLabel;
      return /*#__PURE__*/React__default.createElement(IlSearchV2DropdownItem, {
        key: index,
        name: highlightLabelText && typeof optionLabel === 'string' ? highlightText(optionLabel, searchValue) : optionLabel,
        handleSelect: function handleSelect() {
          return _handleSelect(optionValue, option);
        }
      });
    });
    return _this;
  }
  _inherits(IlSearchV2Dropdown, _Component);
  return _createClass(IlSearchV2Dropdown, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        options = _this$props2.options,
        loading = _this$props2.loading,
        optionsLimit = _this$props2.optionsLimit,
        noOptionsText = _this$props2.noOptionsText;
      return /*#__PURE__*/React__default.createElement("ul", {
        className: "".concat(BASE_CSS, "__dropdown")
      }, loading ? /*#__PURE__*/React__default.createElement("li", {
        className: "".concat(BASE_CSS, "__dropdown__item")
      }, /*#__PURE__*/React__default.createElement(IlSkeletonText, null)) : options.length ? options.slice(0, optionsLimit).map(this.renderDropdownItem) : /*#__PURE__*/React__default.createElement(IlSearchV2DropdownItem, {
        name: noOptionsText
      }));
    }
  }]);
}(Component);
_defineProperty(IlSearchV2Dropdown, "propTypes", {
  searchValue: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  getOptionLabel: PropTypes.func,
  getOptionValue: PropTypes.func,
  highlightLabelText: PropTypes.bool,
  optionsLimit: PropTypes.number.isRequired,
  noOptionsText: PropTypes.string.isRequired,
  handleSelect: PropTypes.func.isRequired
});

export { IlSearchV2Dropdown };
